import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'AROONOSC',
  version: 1,
  label: 'Aroon Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 150,
  inputs: [period('timeperiod', 14)],
  outputs: [line('aroonosc', 'Aroon Osc', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['AROONOSC'], expr: 'AROONOSC(high, low, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
